import { SnapshotIn, types } from "mobx-state-tree";

export const FactoryKey = types.model({
    id: types.string,
    group_key: types.maybeNull(types.string),
  });
  
  export type FactoryKey = SnapshotIn<typeof FactoryKey>